import { render, staticRenderFns } from "./SfLoader.vue?vue&type=template&id=fc220c12&functional=true&"
import script from "./SfLoader.vue?vue&type=script&lang=js&"
export * from "./SfLoader.vue?vue&type=script&lang=js&"
import style0 from "./SfLoader.vue?vue&type=style&index=0&id=fc220c12&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports